@if (displayMenuForm) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="displayMenuForm">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Menu Text </label>
            </div>
            <clickatell-form-validation [controlName]="'text'"
            [form]="displayMenuForm"></clickatell-form-validation>
            <textarea class="control-textArea" activeForm [activeForm]="displayMenuForm" id="text" [formControlName]="'text'"></textarea>
          </div>
          <div class="control-div toggle-field">
            <div class="label-left-block">
              <label class="control-label"> End Session </label>
            </div>
            <div class="toggle-btn">
              <mat-slide-toggle #next [color]="'primary'" class="control-toggle"
                [formControlName]="'endSession'" (change)="sessionEndToggle($event)">
              </mat-slide-toggle>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </clickatell-expansion-panel>
    @if (!next.checked && logicForm) {
      <clickatell-expansion-panel>
        <ng-container header>
          <mat-panel-title>
            Logic
          </mat-panel-title>
        </ng-container>
        <ng-container body>
          <ng-container [formGroup]="logicForm">
            <div class="control-result">
              <div class="control-result-header">
                Next
              </div>
              <div class="control-result-container">
                <div class="control-div">
                  <label class="control-label">
                    <span class="pont-to">Point To</span>
                    <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                  </label>
                  @if (nodeFlowDetails) {
                    <div #nextSelectorContainer></div>
                  }
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </clickatell-expansion-panel>
    }
  </div>
}
